export default __webpack_public_path__ + "feature_engineering_logo.14e8a10b.png";